export const TAXES = "TAXES";
export const TAXES_COUNT = "TAXES_COUNT";
